// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"342":"0d3a9a02","661":"23451500","704":"0d3a9a02","852":"0d3a9a02","889":"0d3a9a02"}[chunkId] + ".chunk.css";
};